var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "identity-page" },
    [
      _vm._m(0),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.identities, size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "identityType", label: "类型", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "姓名", "min-width": "160" },
              }),
              _c("el-table-column", {
                attrs: { prop: "jobType", label: "岗位", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { prop: "staffId", label: "职员ID", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "customerId", label: "客户ID", width: "100" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("MY ACCOUNT")]),
        _c("h2", [_vm._v("我的账号 / 身份")]),
        _c("p", [_vm._v("职员与业主身份复用平台用户，不重复建账号表。")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }